var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 18.5H3.625c-.531 0-.91-.38-.91-.91 0-.494.379-.911.91-.911h12.75c.493 0 .91.417.91.91 0 .532-.417.911-.91.911zm-7.058-5.123L4.46 8.217a.94.94 0 01.038-1.29c.38-.342.948-.342 1.29.037l3.301 3.491V2.411c0-.494.38-.911.911-.911.493 0 .91.417.91.91v8.045l3.264-3.49c.342-.38.91-.38 1.29-.039.38.342.38.911.038 1.29l-4.857 5.161a.888.888 0 01-.645.266.914.914 0 01-.683-.266z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default ForwardRef;